<template>
  <list>
    <div slot="helptext" class="mb-5">
      <p><b>管理员：</b>管理系统配置，查看系统运行状态，管理系统所有用户和角色，并查看所有用户运行状况，设置标签价格和二维码价格，</p>
      <p><b>超级管理员：</b>系统第一次运行时自动生成的账号，用户初始化系统初始信息，生成管理员账号，拥有系统的最高权限</p>
    </div>
  </list>
</template>

<script>
  import List from './list'
  export default {
    name: "user",
    components: {List}
  }
</script>

<style scoped>

</style>